import imagesConverter from "./images-conventer"
import { HttpTypes } from "@medusajs/types"

const getThumbnail = (product: HttpTypes.AdminProduct) => {
  if (product.thumbnail) {
    return imagesConverter(product.thumbnail)
  }

  const firstImageUrl = product.images?.[0]?.url

  return firstImageUrl ? imagesConverter(firstImageUrl) : ""
}

export default function productsImagesFormatter(
  products: HttpTypes.AdminProduct[] | HttpTypes.AdminProduct | undefined
) {
  if (!products) return null

  if (Array.isArray(products)) {
    return products.map((product: HttpTypes.AdminProduct) => ({
      ...product,
      thumbnail: getThumbnail(product),
      images: product.images?.map((image: any) => ({
        ...image,
        url: imagesConverter(image.url || ""),
      })),
    }))
  }

  return {
    ...products,
    thumbnail: getThumbnail(products),
    images: products.images?.map((image: any) => ({
      ...image,
      url: imagesConverter(image.url || ""),
    })),
  }
}
